module.exports = __webpack_public_path__ + "img/22.50538afb.jpg";